import { render, staticRenderFns } from "./ProductPriorityTopContent.vue?vue&type=template&id=2862e722&"
import script from "./ProductPriorityTopContent.vue?vue&type=script&lang=ts&"
export * from "./ProductPriorityTopContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports